import { Component, OnInit } from '@angular/core';
import { DownloadService } from 'src/app/base/services/download.service';

@Component({
  selector: 'app-council-information',
  templateUrl: './council-information.component.html',
  styleUrls: ['./council-information.component.scss']
})
export class CouncilInformationsComponent implements OnInit {

  constructor(private downloadService: DownloadService) { }

  ngOnInit(): void {
  }

  download(name: string, ext: string = null, path: string = null) {
    this.downloadService.download(path, name, ext);
  }
}
